import {
    createElementVNode as _$ce,
    className as _$cn,
    createUnknownComponentVNode as _$cc,
    noop as _$no,
    createVNode as _$cv,
} from 'intact';
import {Icon} from '../icon';
import {addStyle, isTextBlock, getRestProps} from '../utils';
import {makeStyles} from './styles';
import {noop, isNullOrUndefined} from 'intact-shared';
import {Wave} from '../wave';
import {context as ErrorContext} from '../form/useError';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {
        className, style, type, value, defaultValue, placeholder,
        clearable, disabled, size, rows, autoWidth, fluid,
        width, stackClearIcon, frozenOnInput, readonly, inline,
        waveDisabled,
        
        'ev-click': click,
        'ev-mounseenter': mouseenter,
        'ev-mouseleave': mouseleave,
    
        ...rest
    } = this.get();
    
    const {
        inputing: {value: inputing},
        originalValue: {value: originalValue},
        startInput, onInput, endInput
    } = this.frozen;
    
    const classNameObj = {
        'k-input': true,
        [`k-${size}`]: size !== 'default',
        'k-group': $blocks.prepend || $blocks.append,
        'k-disabled': disabled,
        'k-with-prefix': $blocks.prefix,
        'k-with-suffix': $blocks.suffix,
        'k-clearable': clearable,
        'k-auto-width': autoWidth,
        'k-fluid': fluid,
        'k-stack-clear': stackClearIcon,
        'k-inline': inline,
        [className]: className,
        [makeStyles()]: true,
    }
    
    const {fakeRef, width: {value: fakeWidth}} = this.autoWidth;
    
    const inputValue = frozenOnInput && inputing ? originalValue : value;
    const hasInputValue = !isNullOrUndefined(inputValue);
    const hasValue = hasInputValue && inputValue !== '';
    const inputProps = {
        ...getRestProps(this, rest),
        'ev-focus': startInput,
        'ev-blur': endInput,
        'ev-input': onInput,
        defaultValue,
        readOnly: readonly,
        placeholder,
        disabled,
        ref: this.inputRef,
        style: autoWidth ? {width: fakeWidth + 'px'} : undefined,
    };
    // if we pass value to input element, the input is controlled and the
    // defaultValue does not work
    if (hasInputValue) {
        inputProps.value = inputValue;
    }
    return _$ce(2, 'div', [
        do {
            if ($blocks.prepend) {
                // if the children of this block is text node
                // we add a padding to the wrapper node
                // so we handle this block manually
                const children = $blocks.prepend(noop);
                _$ce(2, 'div', children, 0, _$cn({
                    "k-input-prepend": true, 
                    "k-input-padding": isTextBlock(children)
                }))
            }
        },
        _$cc(ErrorContext.Consumer, {
            'defaultValue': false,
            'children': isInvalid => {
                return _$cc(Wave, {
                    'disabled': waveDisabled || disabled || isInvalid,
                    'children': (
                        _$ce(2, 'div', [
                            ($blocks.prefix) ?
                                _$ce(2, 'div', (
                                    (
                                        (_$blocks['prefix'] = function($super) {
                                            return null;
                                        }),
                                        (__$blocks['prefix'] = function($super, data) {
                                            var block = $blocks['prefix'];
                                            var callBlock = function() {
                                                return _$blocks['prefix'].call($this, $super, data);
                                            };
                                            return block ?
                                                block.call($this, callBlock, data) :
                                                callBlock();
                                        }),
                                        __$blocks['prefix'](_$no)
                                    )
                                ), 0, 'k-input-prefix') :
                                undefined,
                            (type !== 'textarea') ?
                                _$cv('input', {
                                    ...inputProps,
                                    'className': 'k-input-inner',
                                    'type': type
                                }) :
                                _$cv('textarea', {
                                    ...inputProps,
                                    'className': 'k-input-inner k-textarea',
                                    'rows': rows
                                }),
                            ($blocks.suffix || clearable && !disabled) ?
                                _$ce(2, 'div', [
                                    (clearable && !disabled) ?
                                        _$cc(Icon, {
                                            'className': _$cn({
                                                "k-input-clear ion-ios-close": true, 
                                                "k-input-show": hasValue,
                                            }),
                                            'ev-click': this.clear,
                                            'hoverable': true
                                        }) :
                                        undefined,
                                    ' ',
                                    (
                                        (_$blocks['suffix'] = function($super) {
                                            return null;
                                        }),
                                        (__$blocks['suffix'] = function($super, data) {
                                            var block = $blocks['suffix'];
                                            var callBlock = function() {
                                                return _$blocks['suffix'].call($this, $super, data);
                                            };
                                            return block ?
                                                block.call($this, callBlock, data) :
                                                callBlock();
                                        }),
                                        __$blocks['suffix'](_$no)
                                    )
                                ], 0, 'k-input-suffix') :
                                undefined,
                            (autoWidth) ?
                                _$ce(2, 'div', !hasValue ? placeholder : inputValue, 0, 'k-input-fake', null, null, fakeRef) :
                                undefined
                        ], 0, 'k-input-wrapper')
                    )
                })
            }
        }),
        do {
            if ($blocks.append) {
                const children = $blocks.append(noop);
                _$ce(2, 'div', children, 0, _$cn({
                    "k-input-append": true, 
                    "k-input-padding": isTextBlock(children)
                }))
            }
        }
    ], 0, _$cn(classNameObj), {
        'style': width != null ? addStyle(style, {width: `${width}px`}) : style,
        'ev-click': click,
        'ev-mouseenter': mouseenter,
        'ev-mouseleave': mouseleave
    });
};